import { render, staticRenderFns } from "./AdminSiteNewsView.vue?vue&type=template&id=33e59855&scoped=true"
import script from "./AdminSiteNewsView.vue?vue&type=script&lang=js"
export * from "./AdminSiteNewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e59855",
  null
  
)

export default component.exports